import React from 'react';
import { isPropsValid } from '@fullcalendar/core';
const MyTeam = (props) => {
    return (<div className="p-col-12 p-lg-12 contacts">
        <ul>
            {props.data && props.data.length > 0 ?
                props.data.map((team, index) => <li key={index}>
                    <button className="p-link">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={require('../../../../assets/images/profile.jpg')} width="35" alt="Mohamed Noohu" />
                                <span style={{ marginLeft: '10px', fontSize: '18px' }}>{team.name}</span>
                            </div>
                            <span>{team.positionname}</span>
                        </div>
                    </button>
                </li>) :
                <li>
                    <button className="p-link">
                        <span className="name">No List.</span>
                    </button>
                </li>}
        </ul>
    </div>

    );
}

export default MyTeam;